import { ModuleWithProviders, NgModule } from '@angular/core';
import { AuthenticationService } from './services/authentication.service';
import { UserService } from './services/user.service';
import { CanDirective } from './directives/can.directive';
import { AuthGuard } from './guards/auth.guard';
import { MultiTenantService } from './services/multi-tenant.service';
import { TenantService } from './services/tenant.service';
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { AuthHttpInterceptor } from './classes/auth-http-interceptor';

@NgModule({
    imports: [],
    declarations: [CanDirective],
    providers: [
        AuthGuard,
        AuthenticationService,
        TenantService
    ],
    exports: [CanDirective]
})
export class AuthenticationModule {

    public static forRoot(): ModuleWithProviders {
        return {
            ngModule: AuthenticationModule,
            providers: [
                AuthenticationService,
                MultiTenantService,
                UserService,
                {
                    provide: HTTP_INTERCEPTORS,
                    useFactory: (auth) => {
                        return new AuthHttpInterceptor(auth);
                    },
                    deps: [AuthenticationService],
                    multi: true
                }
            ]
        };
    }

}



// WEBPACK FOOTER //
// ./libs/chassis-core/src/app/authentication/authentication.module.ts